export default __webpack_public_path__ + "static/media/lascondes_logo.236e2580.png";